<template>
  <div>
    <send-result-window v-if="show_send_result_window"
      :subject_id="send_result_subject_id"></send-result-window>

    <div xv-if="!show_send_result_window" class="max-w-4xl mx-auto">
      <start_message v-if="!init_status"></start_message>
      <page-header v-if="init_status"></page-header>

      <pre v-if="debug">
      DEPARTMENT
      {{ department }}
      TOPICS
      {{ topics }}
      SUBJECTS
      {{ subjects }}
      BLOCKS
      {{ blocks }}
      QUIZ BLOCKS
      {{ quiz_blocks_status }}
      </pre>

      <div v-if="init_status" class="max-w-4xl mt-12 mb-12 sm:mt-20 px-4 lg:px-0">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import EventBus from './api/event-bus'
import { mapState, mapActions, mapMutations } from "vuex"

import start_message from './components/start_message.vue'
import PageHeader from './components/page_header.vue'
import SendResultWindow from './components/send_result_window.vue'

export default {
  data() {
    return {
      debug: false,
      show_send_result_window: false,
      send_result_subject_id: null
    }
  },
  components: {
    start_message,
    PageHeader,
    SendResultWindow
  },
  computed: {
    ...mapState(["init_status", "error",
                 'department_id', 'department', 'topics', 'subjects', 'blocks',
                 'quiz_blocks_status'])
  },
  methods: {
    ...mapMutations(["clear_session",
                     "set_error",
                     "init_done",
                     "init_start",
                     "set_department_id",
                     "set_department",
                     "set_consultants",
                     "set_topics",
                     "set_subjects",
                     "set_blocks",
                     "set_current_department_id"]),
    ...mapActions(['set_department_id', "fetch_content", "prepare_quiz_blocks"])
  },
  async created() {

    EventBus.on( 'send-multimedia-ping', (data) => {
      axios.post(`/api/v1/ping`, data)
           .then((response) => {
             console.log('media-data sent')
           }).catch(e => {
             console.log('ping caught error')
           })
    })

    EventBus.on( 'display-send-result-window', (subject_id) => {
      // this.send_result_subject_id = subject_id
      // this.show_send_result_window = true
    })

    EventBus.on( 'close-send-result-window', () => {
      // this.send_result_subject_id = null
      // this.show_send_result_window = false
    })

    await this.init_start()
    await this.set_department_id(window.department_id)
    await this.set_current_department_id(this.department_id)

    await axios.get(`/api/v1/contents/${this.department_id}.json`)
               .then((response) => {
                 if( response.status == 200 ) {
                   this.set_department( response.data.department )
                   this.set_consultants( response.data.consultants )
                   this.set_topics( response.data.topics )
                   this.set_subjects( response.data.subjects )
                   this.set_blocks( response.data.blocks )
                   this.prepare_quiz_blocks()
                   this.init_done()
                 } else {
                   this.set_error()
                 }
               }).catch( e => {
                 this.set_error()
               })
  },
}
</script>
